var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')
var _ = require('lodash')

var Emergencies = function () {
  var cached = {}

  // init
  var Emergency = BaseModel.extend({
    urlRoot: Config.api.host + '/emergencies',
    defaults: {
      location: [],
      radius: 0,
      duration: 0,
      enable: 0
    }
  })

  // var EmergenciesCollection = BaseCollection.extend({
  //   url: Config.api.host + '/emergencies',
  //   idAttribute: '_id',
  //   model: Emergency
  //   // parse: function (data) {
  //   //   if (!data.data) return data
  //   //   return data.data
  //   // }
  // })

  // //
  var API = {
    newEmergencyEntity: function () {
      return new Emergency()
    },
    initialize: function (callback) {

    }
  }

  App.globalChannel.reply('emergency:entity:new', function () {
    return API.newEmergencyEntity()
  })

  // Init
  return API
//
}

module.exports = Emergencies



// WEBPACK FOOTER //
// ./js/entities/emergencies.js